module.exports = __webpack_public_path__ + "img/icon2.7b260c04.png";